import React, { useContext } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { getSemanticValue, Link, Spaces } from '@freenow/wave';

import { RemoteSettingsContext } from '../../common/context/RemoteSettingsContext';
import { SignUpContext } from '../context/SignUpContext';
import { LanguageSwitcher } from '../../LoggedInBootstrap/components/LanguageSwitcher';
import { getBrowserLocale } from '../../common/helpers/translation';

const FooterContainer = styled.footer`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${Spaces[1]} ${Spaces[5]};
    border-top: 1px solid ${getSemanticValue('border-neutral-faded')};
`;

function getCountryCodeFromLocale() {
    const browserLocale = getBrowserLocale();
    let country;

    if (browserLocale.length === 2) {
        country = browserLocale;
    } else {
        country = browserLocale.substring(3, 5);
    }

    return country;
}

export const SignUpFooter = () => {
    const {
        businessAccountDraft: { countryCode },
    } = useContext(SignUpContext);
    const { getSettings } = useContext(RemoteSettingsContext);

    const settings = countryCode ? getSettings(countryCode) : getSettings(getCountryCodeFromLocale());

    if (!settings) {
        return null;
    }

    return (
        <FooterContainer>
            {settings.dataPrivacyLink ? (
                <Link fontSize={0} target="_blank" rel="noopener noreferrer" href={settings.dataPrivacyLink} m={1}>
                    <FormattedMessage id="signUp.createAccount.footer.dataPrivacy" />
                </Link>
            ) : null}
            {settings.legalNoteLink ? (
                <Link fontSize={0} target="_blank" rel="noopener noreferrer" href={settings.legalNoteLink} m={1}>
                    <FormattedMessage id="signUp.createAccount.footer.imprint" />
                </Link>
            ) : null}
            {settings.generalTermsConditions.link ? (
                <Link
                    fontSize={0}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={settings.generalTermsConditions.link}
                    m={1}
                >
                    <FormattedMessage id="signUp.createAccount.footer.termAndConditions" />
                </Link>
            ) : null}
            <LanguageSwitcher />
        </FooterContainer>
    );
};
